export const paymentFieldMapping = {
  transaction: [
    'id',
    'createdDateTime',
    'clientRequestReference',
    'smartsPaymentReference',
    'transactionType',
    'transactionResult',
    'operatorId',
    'amount',
    'currency',
    'errorCode',
    'errorMessage'
  ],
  paymentScheme: [
    'paymentScheme.id',
    'paymentScheme.name',
    'paymentScheme.description',
    'paymentScheme.enabled',
    'paymentScheme.startDateTime',
    'paymentScheme.endDateTime',
    'paymentScheme.preloadedAmount',
    'paymentScheme.requestBasketContent',
    'paymentScheme.ecrTenderTypeCode',
    'paymentScheme.currency',
    'paymentScheme.redemptionFrequencyDays',
    'paymentScheme.expiryPeriod',
    'paymentScheme.expiryPeriodUnit',
    'paymentScheme.unitOfMeasureType',
    'paymentScheme.unitOfMeasure',
    'paymentScheme.printPaymentVoucher',
  ],
  paymentToken: [
    'paymentToken.id',
    'paymentToken.name',
    'paymentToken.createdDateTime',
    'paymentToken.activationDateTime',
    'paymentToken.expiryDateTime',
    'paymentToken.balance',
    'paymentToken.status',
  ],
  store: [
    'storeId',
    'storeName',
    'storeRetailerRef'
  ],
  device: ['deviceId', 'deviceName'],
}
